import { render, staticRenderFns } from "./help&support.vue?vue&type=template&id=6e977b2a&scoped=true"
import script from "./help&support.vue?vue&type=script&lang=js"
export * from "./help&support.vue?vue&type=script&lang=js"
import style0 from "./help&support.vue?vue&type=style&index=0&id=6e977b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e977b2a",
  null
  
)

export default component.exports